<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('sales_distribution_admin.delivery_order') + ' ' + $t('globalTrans.entry') }}</h4>
                    </template>
                    <template v-slot:headerAction>
                        <router-link to="delivery-orders" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{  $t('sales_distribution_admin.delivery_order') + ' ' + $t('globalTrans.list') }}</router-link>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loading">
                            <b-row>
                                <b-col lg="12" sm="12" class="text-center mb-4">
                                    <h5 class='complain-title'>{{ $t('sales_distribution_admin.add_new_delivery_order') }}</h5>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
                                            <b-row>
                                                <b-col lg="3" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="category_id "
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('production_configuration.case_mapping.product_category')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.category_id"
                                                        id="category_id"
                                                        :options="categoryList"
                                                        :disabled="disableCat"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="sub_category_id "
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('production_configuration.case_mapping.product_sub_category')}}
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.sub_category_id"
                                                        id="sub_category_id"
                                                        :options="subCategoryList"
                                                        :disabled="disableSubCat"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="product_id "
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('production_configuration.case_mapping.product_name')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.product_id"
                                                        id="product_id"
                                                        :options="productList"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="unit_id"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('sales_distribution_admin.pro_unit')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.unit_id"
                                                        id="unit_id"
                                                        :options="productUnitList"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="available_quantity"
                                                    >
                                                        <template v-slot:label>
                                                        {{ $t('sales_distribution_admin.available_quantity')}}
                                                        </template>
                                                        <b-form-input
                                                        id="available_quantity"
                                                        v-model="detailsFormData.available_quantity"
                                                        disabled
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <ValidationProvider name="Quantity" :rules="'max_value:' + available">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="quantity"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('sales_distribution_admin.quantity')}}
                                                            </template>
                                                            <b-form-input
                                                                type="number"
                                                                @input="changeQty()"
                                                                v-model="detailsFormData.delivery_quantity"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <ValidationProvider name="Unit Price" vid="unit_price" :rules="{required: true, regex: /^\d*\.?\d*$/}">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="unit_price"
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                                {{ $t('retailerManagement.unit_price') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                id="unit_price"
                                                                v-model="detailsFormData.unit_price"
                                                                @input="changePrice()"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="total"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('retailerManagement.total_price') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            readonly
                                                            id="total"
                                                            v-model="detailsFormData.total"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="3" sm="12">
                                                    <ValidationProvider name="Free Product" vid="is_free">
                                                        <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="is_free"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('sales_distribution_admin.free_product') }}
                                                        </template>
                                                        <b-form-checkbox
                                                            id="is_free"
                                                            v-model="detailsFormData.is_free"
                                                            value="true"
                                                            unchecked-value="false"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >{{ $t('production_service_config.yes') }}</b-form-checkbox>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button @click.prevent="addItem()" variant="primary" class="mr-2"><i class="ri-add-circle-line"></i>{{ $t('globalTrans.add') }}</b-button>
                                                </div>
                                            </div>
                                            <hr>
                                            <b-row class="mt-4">
                                                <b-col>
                                                    <b-overlay :show="unitLoad">
                                                    <table class="table table-bordered">
                                                        <tr class="bg-light">
                                                            <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                            <th>{{ $t('production_configuration.case_mapping.product_name') }}</th>
                                                            <th>{{ $t('sales_distribution_admin.pro_unit') }}</th>
                                                            <th>{{ $t('sales_distribution_admin.available_quantity') }}</th>
                                                            <th>{{ $t('sales_distribution_admin.quantity') }}</th>
                                                            <th>{{ $t('retailerManagement.unit_price') }}</th>
                                                            <th>{{ $t('retailerManagement.total_price') }}</th>
                                                            <th>{{ $t('globalTrans.action') }}</th>
                                                        </tr>
                                                        <tr v-for="(item, index) in dataArray.details" :key="index">
                                                            <td>{{ $n(index + 1) }}</td>
                                                            <td>{{ productNameById(item.product_id) }}<span class="badge badge-success ml-2">{{ item.is_free ? $t('retailerManagement.free_gift') : '' }}</span></td>
                                                            <td>{{ unitNameById(item.unit_id) }}</td>
                                                            <td>{{ item.available_quantity }}</td>
                                                            <td>
                                                                <ValidationProvider name="Quantity" :rules="'max_value:' + item.available_quantity">
                                                                    <b-form-group
                                                                        class="mb-0"
                                                                        slot-scope="{ valid, errors }"
                                                                    >
                                                                        <b-form-input
                                                                        v-model="item.delivery_quantity"
                                                                        @input="changeItemQty(item)"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                        ></b-form-input>
                                                                        <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                        </div>
                                                                    </b-form-group>
                                                                </ValidationProvider>
                                                            </td>
                                                            <td>
                                                                <ValidationProvider name="Unit Price" :rules="{required: true, regex: /^\d*\.?\d*$/}">
                                                                    <b-form-group
                                                                    slot-scope="{ valid, errors }"
                                                                    >
                                                                        <b-form-input
                                                                        :readonly="dataArray.type_id == 1 ? true : false"
                                                                        v-model="item.unit_price"
                                                                        @input="changeItemPrice(item)"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                        ></b-form-input>
                                                                        <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                        </div>
                                                                    </b-form-group>
                                                                </ValidationProvider>
                                                            </td>
                                                            <td>{{ item.total }}</td>
                                                            <td>
                                                                <button type="button" @click="deleteItem(index)" class="btn btn-danger btn-xs"><i class="fa fa-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                        <b-td colspan="6">
                                                            <p style="margin-left:85%">{{ $t('sales_center.grand_total') }}</p>
                                                        </b-td>
                                                        <b-td colspan="2">{{ getGrandTotal() }}</b-td>
                                                    </table>
                                                    </b-overlay>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                            <b-row>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Delivery Date" vid='delivery_date' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="delivery_date"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('sales_distribution_admin.delivery_date')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                            placeholder="Select Date"
                                                            id="delivery_date"
                                                            v-model="dataArray.delivery_date"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Sales" vid="sales_center_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="sales_center_id"
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                                {{$t('sales_distribution_admin.sales_center')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                            plain
                                                            v-model="dataArray.sales_center_id"
                                                            :options="salesCenterList"
                                                            @change="getOrg(dataArray.sales_center_id)"
                                                            id="sales_center_id"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                            </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Contact No" vid="contuct_no" rules="required|min:11|max:11">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="contuct_no"
                                                            slot-scope="{ valid, errors }"
                                                            >
                                                            <template v-slot:label>
                                                            {{ $t('sales_distribution_admin.contact_no')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                            type="text"
                                                            id="contuct_no"
                                                            v-model="dataArray.contact_no"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Manual Bill No." vid='manual_bill_no' rules="numeric">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="manual_bill_no"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('retailerManagement.manual_bill_no')}}
                                                            </template>
                                                            <b-form-input
                                                            placeholder=""
                                                            id="manual_bill_no"
                                                            v-model="dataArray.manual_bill_no"
                                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Delivery Spot" vid='delivery_spot'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="delivery_spot"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('sales_distribution_admin.delivery_spot')}}
                                                            </template>
                                                            <b-textarea
                                                            id="delivery_spot"
                                                            v-model="dataArray.delivery_place"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-textarea>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12" v-if="currentLocale == 'en'">
                                                    <ValidationProvider name="Comment (En)" vid='comment'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="comment"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('sales_distribution_admin.remark_en')}}
                                                            </template>
                                                            <b-textarea
                                                            id="comment"
                                                            v-model="dataArray.comment"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-textarea>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12" v-else>
                                                    <ValidationProvider name="Comment (Bn)" vid='comment_bn'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="comment_bn"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('sales_distribution_admin.remark_bn')}}
                                                            </template>
                                                            <b-textarea
                                                            id="comment_bn"
                                                            v-model="dataArray.comment_bn"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-textarea>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <div class="row">
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                    &nbsp;
                                                    <b-button @click="cancel()" variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
// import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { availableStockInfo, deliveryOrderEntryApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            saveBtnName: this.$t('sales_distribution_admin.deliver'),
            detailsFormData: {
                category_id: 0,
                sub_category_id: 0,
                product_id: 0,
                unit_id: 0,
                delivery_quantity: '',
                available_quantity: '',
                unit_price: 0,
                total: 0,
                is_free: false
            },
            dataArray: {
                product_type: 1,
                delivery_place: '',
                manual_bill_no: '',
                org_id: 0,
                sales_center_id: 0,
                delivery_date: '',
                comment: '',
                comment_bn: '',
                contact_no: '',
                details: []
            },
            available: '',
            sl: 0,
            subCategoryList: [],
            productList: [],
            productUnitList: [],
            loading: false,
            unitLoad: false,
            total_quantity: '',
            disableCat: false,
            disableSubCat: false
        }
    },
    watch: {
        'detailsFormData.category_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.disableCat = true
                this.dataArray.product_type = newVal
                if (newVal === 1) {
                    this.disableSubCat = false
                    this.subCategoryList = this.getSubCatList(newVal)
                } else {
                    this.disableSubCat = true
                    this.detailsFormData.sub_category_id = 0
                }
                this.productList = this.getProductListByCat(newVal)
                this.subCategoryList = this.getSubCatList(newVal)
            }
        },
        'detailsFormData.sub_category_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.productList = this.getProductList(newVal)
            }
        },
        'detailsFormData.product_id': function (newVal, oldVal) {
            if (newVal !== oldVal && newVal !== parseInt(0)) {
                this.productUnitList = this.getProductUnitList(newVal)
                this.detailsFormData.unit_id = 1
            }
        },
        'detailsFormData.unit_id': function (newVal, oldVal) {
            if (newVal !== oldVal && newVal !== parseInt(0)) {
                this.getAvailableQuantity(newVal, this.detailsFormData.product_id)
            }
        },
        currentLocale: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localizeUserList(newVal)
            }
        }
    },
    computed: {
        categoryList: function () {
            return this.productCommonObj.productCategoryList.filter(item => item.status === 1)
        },
        salesCenterList: function () {
            return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
        },
        currentLocale: function () {
            return this.$i18n.locale
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    mounted () {
            flatpickr('#delivery_date', {})
    },
    created () {
    },
    methods: {
        changeQty () {
            if (this.detailsFormData.unit_price) {
                const result = this.detailsFormData.delivery_quantity * parseFloat(this.detailsFormData.unit_price)
                this.detailsFormData.total = parseFloat(result.toFixed(2))
            }
        },
        changePrice () {
            if (this.detailsFormData.delivery_quantity) {
                const result = this.detailsFormData.delivery_quantity * parseFloat(this.detailsFormData.unit_price)
                this.detailsFormData.total = parseFloat(result.toFixed(2))
            }
        },
        changeItemPrice (item) {
            if (item.delivery_quantity) {
                const result = item.delivery_quantity * parseFloat(item.unit_price)
                item.total = parseFloat(result.toFixed(2))
            }
        },
        changeItemQty (item) {
            if (item.unit_price) {
                const result = item.delivery_quantity * parseFloat(item.unit_price)
                item.total = parseFloat(result.toFixed(2))
            }
            if (item.available_quantity < parseFloat(item.delivery_quantity)) {
                item.message = 'Sales quantity must not be greater than available quantity'
            } else {
                item.message = ''
            }
        },
        getGrandTotal () {
            const total = this.dataArray.details.reduce((total, item) => total + item.total, 0)
            // this.dataArray.grandTotal = total
            // this.dataArray.totalPrice = this.dataArray.after_discount ? this.dataArray.after_discount : total
            // this.dataArray.totalPrice = this.dataArray.after_vat ? this.dataArray.after_vat : this.dataArray.totalPrice
            return total
        },
        getOrg (officeId) {
            const Org = this.$store.state.commonObj.officeList.find(el => el.value === officeId)
            this.dataArray.org_id = Org.org_id
        },
        getAvailableQuantity (unitId, productId) {
            const products = {
                product_ids: [productId],
                unit_ids: [unitId]
            }
            this.unitLoad = true
            RestApi.getData(productionServiceBaseUrl, availableStockInfo, products)
            .then(response => {
                if (response.data.length > 0) {
                    this.available = response.data[0].quantity
                    this.detailsFormData.available_quantity = response.data[0].quantity
                    this.detailsFormData.unit_price = response.price[0].recommended_price
                } else {
                    this.available = 0
                    this.detailsFormData.unit_price = 0
                    this.detailsFormData.available_quantity = 0
                }
                this.unitLoad = false
            })
        },
        deleteItem (index) {
            this.dataArray.details.splice(index, 1)
        },
        cancel () {
            this.detailsFormData = {
                category_id: 0,
                sub_category_id: 0,
                product_id: 0,
                unit_id: 0,
                delivery_quantity: '',
                available_quantity: '',
                is_free: false
            }
            this.$router.push({ path: '/production-service/sales-distribution-admin/delivery-orders' })
            this.dataArray.details = []
            this.dataArray.delivery_place = ''
        },
        addItem () {
            if (this.detailsFormData.category_id !== 0 && this.detailsFormData.product_id !== 0 && this.detailsFormData.unit_id !== 0 && this.detailsFormData.delivery_quantity !== '') {
                const existsCategory = this.dataArray.details.some(data => data.category_id === this.detailsFormData.category_id)
                const existsProduct = this.dataArray.details.some(data => data.product_id === this.detailsFormData.product_id)
                const existsUnit = this.dataArray.details.some(data => data.unit_id === this.detailsFormData.unit_id)
                if (existsCategory && existsProduct && existsUnit) {
                    this.dataArray.details.forEach((result, index) => {
                        if (result.category_id === this.detailsFormData.category_id && result.product_id === this.detailsFormData.product_id && result.unit_id === this.detailsFormData.unit_id) {
                            const totalVal = parseInt(result.delivery_quantity) + parseInt(this.detailsFormData.delivery_quantity)
                            this.dataArray.details[index].delivery_quantity = totalVal
                            const categoryId = this.detailsFormData.category_id
                            this.detailsFormData = {
                                category_id: categoryId,
                                sub_category_id: 0,
                                product_id: 0,
                                unit_id: 0,
                                delivery_quantity: '',
                                available_quantity: '',
                                unit_price: 0,
                                total: 0,
                                is_free: false
                            }
                            this.dataArray.delivery_place = ''
                        }
                    })
                } else {
                    this.dataArray.details.push(this.detailsFormData)
                    const categoryId = this.detailsFormData.category_id
                    this.detailsFormData = {
                        category_id: categoryId,
                        sub_category_id: 0,
                        product_id: 0,
                        unit_id: 0,
                        delivery_quantity: '',
                        available_quantity: '',
                        unit_price: 0,
                        total: 0,
                        is_free: false
                    }
                    this.dataArray.delivery_place = ''
                }
            }
        },
        async saveData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadingState = { loading: false, listReload: false }
            this.loading = true
            result = await RestApi.postData(productionServiceBaseUrl, deliveryOrderEntryApi, this.dataArray)
            loadingState.listReload = true
            this.$store.dispatch('mutateCommonProperties', loadingState)
            this.loading = false
            if (result.success) {
                if (result.notification && this.$store.state.emitNotification) {
                    const notification = result.notification
                    this.$socket.emit('send-notification', notification)
                }
                this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$router.push({ path: '/production-service/sales-distribution-admin/delivery-orders' })
            } else {
                this.$toast.error({
                    title: '',
                    message: result.message,
                    color: '#D6E09B'
                })
                this.$refs.form.setErrors(result.errors)
            }
        },
        getSubCatList (categoryId = null) {
            const subCategoryList = this.$store.state.ProductionService.commonObj.productSubCategoryList.filter(item => item.status === 1)
            if (categoryId) {
                return subCategoryList.filter(subcategory => subcategory.category_id === categoryId && subcategory.type_id === 2)
            }
            return subCategoryList
        },
        getProductListByCat (catId) {
            return this.productCommonObj.productList.filter(item => item.status === 1 && item.category_id === catId && item.type_id === 2)
        },
        getProductList (subCatId) {
            return this.productCommonObj.productList.filter(item => item.status === 1 && item.sub_category_id === subCatId && item.type_id === 2)
        },
        getProductUnitList (productId = null) {
            const unitList = this.$store.state.ProductionService.commonObj.productUnitList.filter(el => el.status === 1)
            if (productId) {
                return unitList.filter(unit => unit.product_id === productId)
            }
            return unitList
        },
        productCategoryById (id) {
            const category = this.productCommonObj.productCategoryList.find(category => category.value === id)
            if (this.$i18n.locale === 'bn') {
                return category.text_bn
            } else {
               return category.text_en
            }
        },
        productSubCategoryById (id) {
            const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
            if (this.$i18n.locale === 'bn') {
                return subCategory.text_bn
            } else {
               return subCategory.text_en
            }
        },
        productNameById (id) {
            const product = this.productCommonObj.productList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
               return product.text_en
            }
        },
        unitNameById (id) {
            const unit = this.productCommonObj.productUnitList.find(unit => unit.value === id)
            if (this.$i18n.locale === 'bn') {
                return unit.text_bn
            } else {
               return unit.text_en
            }
        }
    }
}
</script>
